module.exports = "<div class=\"container\">\r\n  {{item.text}}\r\n</div>\r\n\r\n"